import { Button, Modal, ModalVariants } from '@comptia-sso/core';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { i18n } from 'i18n';

// Hooks.
import { useAuthLogout } from 'hooks';

// Styles.
import styles from './AccountDeletionModal.module.scss';

interface IAccountDeletionModalProps {
  open: boolean;
}

const HELP_URLS: Record<string, string> = {
  ja: 'https://helpjp.comptia.org/hc/ja',
  en: 'https://help.comptia.org/',
};

export const AccountDeletionModal = ({
  open,
}: IAccountDeletionModalProps): ReactElement => {
  const { t } = useTranslation();
  const logout = useAuthLogout();

  const helpUrl = HELP_URLS[i18n.language] || HELP_URLS.en;

  return (
    <Modal
      disableClose
      open={open}
      title={t('AccountDeletion.Title')}
      variant={ModalVariants.Small}
    >
      <div className={styles.content}>
        <p>
          {t('AccountDeletion.Message')}{' '}
          <a href={helpUrl} target="_blank" rel="noopener noreferrer">
            {t('AccountDeletion.ContactUs')}
          </a>
        </p>
        <Button className={styles.fullWidth} onClick={() => logout()}>
          {t('AccountDeletion.SignOut')}
        </Button>
      </div>
    </Modal>
  );
};
